import React from 'react';

export default function InputBox({ Type = 'text', Name, PlaceHolder, value, ChangeValue, Class }) {
  if (Type === 'textarea') {
    return (
      <textarea
        name={Name}
        placeholder={PlaceHolder}
        value={value}
        onChange={e => ChangeValue && ChangeValue(e.target.value)}
        className={`form-control ${Class || ''}`}
      />
    );
  }
  return (
    <input
      type={Type}
      name={Name}
      placeholder={PlaceHolder}
      value={value}
      onChange={e => ChangeValue && ChangeValue(e.target.value)}
      className={`form-control ${Class || ''}`}
    />
  );
}
